import { NgModule } from '@angular/core';
import { ThemeModule } from '../../@theme/theme.module';
import { ActividadDetalleComponent } from './actividad-detalle.component';
import { Ng2SmartTableModule } from 'ng2-smart-table';
import { FroalaEditorModule, FroalaViewModule } from 'angular-froala-wysiwyg';
import { AngularEditorModule } from '@kolkov/angular-editor';


@NgModule({
  imports: [
    ThemeModule,
    Ng2SmartTableModule,
    FroalaEditorModule.forRoot(), 
    FroalaViewModule.forRoot(),
    AngularEditorModule 
  ],
  declarations: [
    ActividadDetalleComponent
  ],
})
export class ActividadDetalleModule { }
